// Thin wrapper around @headless-shell/shared-auth that wires up the shell's
// http client, config, and PLRU convention. All auth helpers re-exported here
// delegate to a single client instance so behavior cannot drift between the
// shell and MFEs.
import { createAuthClient, createWebStorage } from '@headless-shell/shared-auth';
import axios from 'src/utils/interceptor';
import { CONFIG } from './config';

export { decodeJWT } from '@headless-shell/shared-auth';

// PLRU convention used by the shell: attach `?returnUrl=<encoded>` to the
// configured base so the AppShell can route the user post-login.
const buildPostLoginRedirect = (base, returnUrl) => {
  if (!returnUrl) return base || '';
  if (!base) return returnUrl;
  const sep = base.includes('?') ? '&' : '?';
  return `${base}${sep}returnUrl=${encodeURIComponent(returnUrl)}`;
};

const authClient = createAuthClient({
  http: axios,
  storage: createWebStorage(),
  authBaseUrl: () => CONFIG.AUTH_BASE_URL,
  postLoginRedirectUri: () => CONFIG.POST_LOGIN_REDIRECT_URI,
  buildPostLoginRedirect,
});

export const {
  getAuthenticated,
  getState,
  getStoredIdToken,
  getEncodedJWT,
  getJWT,
  getJWTSub,
  clearAuth,
  requiresSso,
  login,
  logout,
  getIdToken,
  authStatus,
  checkSession,
  ensureSession,
} = authClient;

export const resolveAuthState = (preferredState = '') => preferredState || getState();

// UI helper — strips a temporary query param after smart-search login redirect.
// Lives here because callers already import from utils/auth.
export const openSmartSearchOnLogin = (urlParams) => {
  urlParams.delete('openSmartSearch');
  const newUrl = urlParams.toString()
    ? `${window.location.pathname}?${urlParams.toString()}`
    : window.location.pathname;
  window.history.replaceState({}, '', newUrl);
};

export default authClient;
